import { DATA_TABLE_COMMON_NAMESPACE } from '@frontends/data-table';
import { DS_COMMON_NAMESPACE } from '@frontends/ds';
import { FEATURE_DEMO_BALANCE_NAMESPACE } from '@frontends/feature-demo-balance';
import { FEATURE_IB_NAMESPACE } from '@frontends/feature-ib';
import { FEATURE_TRADING_SESSION_ALERT_NAMESPACE } from '@frontends/feature-trading-session-alert';
import { initI18n } from '@frontends/util-i18n';
import { getEntityConfig } from '@/hooks/useEntityConfig';

const i18n = initI18n({
  namespaces: [
    'translation',
    DATA_TABLE_COMMON_NAMESPACE,
    DS_COMMON_NAMESPACE,
    FEATURE_DEMO_BALANCE_NAMESPACE,
    FEATURE_IB_NAMESPACE,
    FEATURE_TRADING_SESSION_ALERT_NAMESPACE,
  ],
  defaultNS: 'translation',
  loadPath: '/locales/{{lng}}/{{ns}}.json',
  offeredLanguages: getEntityConfig().VITE_CLIENT_PORTAL_SUPPORTED_LOCALES,
});

export default i18n;
